 export const ProductCategory = [
    {
      id: 1,
      name: 'iPhone 14',
      price: 103999,
      category: 'Mobiles',
      description: 'The iPhone 14 features a sleek design, powerful A15 Bionic chip, dual-camera system, and improved battery life.',
      image:'https://th.bing.com/th/id/OIP.3Jmu9Vp6t3XXsgRdGG9t2QAAAA?rs=1&pid=ImgDetMain&cb=idpwebpc1' 
    },
    {
      id: 2,
      name: 'Samsung Galaxy S24',
      price: 78099,
      category: 'Mobiles',
      description: 'Samsung Galaxy S24 offers a stunning AMOLED display, Snapdragon 8 Gen 2, and pro-grade triple-lens camera.',
      image: 'data:image/webp;base64,UklGRqwOAABXRUJQVlA4IKAOAABQQwCdASq+AL4APp1GnEqlo6YrpzYMkXATiWMA0uElyaXSR/twV5gPN804TeaK+sxs9OvzyawTD/yeKngEPY6rn7J4EOpT4O6I/Bd+1f9T2Bv5l/hvRmz6vWHsHfrp6aHsM/bv2J/19PRwlQMv2EEIRHJhXjjwqQaDlILEqxIPOVY1MvYZwEjNrby7DTL1qF957drg272AKcb5srKJlpoWyiX1JarnYe5JmF+bgKVVTupYfqiQqEVVrHUYHnec0u/cjaZ6Kt/ckddu1PPopgUSCUB+ShBvduRRN1Ewl0TqyNMx92/HMtWRDxolYXq1mn1o1zAv6qhL3s5MNTqkrpYwc8WPtm3Z0aYIqfq5VoXzvUWCLjC+7DSUPgIefqrrO4TD8E5/UJrnTDFNNruQky17kLaOTKJa54L0UCxvBZhyyDtB6sOIzHNTZtDbCeIPfArThlNCN73vvpYgbg5IGJhG2Bcyt2hVhZXS9D6ABdhRM5MeKmS5Zhd1zwoSOy4927Onazk4H1do10/95CGW6QPINmwfFcj7q9iARl4+d4u6v2POI/AVKMrmLqwwZuZN0H50/yfO+fD8FsBfkQJR1UGCdALaWSvMvMFiUg5K8OH5ZTnjVAa2tFhS/SGCS65foeBmM57nuj+5p0HTQ4yiE7BwMwCivmGmhD8382FMcb7XjyQeKFytM73Rv+IM/z2Rr/0+VUn73ve973ve973ve973vcYAAP77IYuc4PwteFU4Lz9aOh527LCjq+/cTZojsT77AAhRU4L+QjV2YgoWbqTPVYB2bJHEGtJEzuOUxC/yi7tKi59Vznh0Wu1MR+WpEJa/b6N1R+XWytgfe9isXb0rxpE8uNyRzSdWpI4lM+yQqcEDDsahw6fpmyo/+RrKvnoyi8o2jehNN2w5vMpDDQ9IdVHnw7U0E7hrqCm73it4AbU7qiPQEyiSAVNWlen9QodRQxverIij3iMhZ4a1BsZPwRx9LZM3NBfI6KfL/SfczlYGLhjBaVXh3wcPIN/tEK1sQFHLSOO0WLOP+XlcH7ApFIES0qDdhKKgSFv6Q+kxgPAdVl1auLDe9rjVy7Or7J576YOkyUhN6gLjacozV3INE0z2bUAJKZjEBYUUN96iWMhw/aeGf2ThkcYXdyff5UEWDMx8sv//ye/4E/AZELILGNSHeIryOOxJNnrJ3SwcDY8bi81FyunY2rvATf5+LDylBXnNyQwm0TXe8EaYlwMn3jKAkNnGUBZw8r8LSqdnnOk1wqC5BC5SFo8+4GuYaFLAIN+Vw/iVGG8mMRlXygfjVPMDWTfinPyVoZ03zTQlRfcySgFSxDHEj/A2Ohokc1iGgjzAywlj5V0v2zVr0RQBSs0xr1EUvjBRDVPh5z2UlULM6AKY3jc+etbFOyAEHKyWmmH8Muis0T4BOqMj63xevLVXN9O6ctACJCGm9kTDJJgS6qqELnJSz076RDRLhBS9rUl/BXwgVpyUZ6byNdW1fp0umK3Ai3oSXjwVSzU1RtenzgBrQZEZXvE3sjL7Sqes0qU3FjsUV8NzsoMBfuJnRkq43mMiyprBJlVyDaPWBYbdkVaCfRIUPgqbQdo/MdtvuExl9urDTPAsU5G/A9UFSUJEZTpUKPI1/bAMukRPQTzloXyzQCvzAvnN1z0hm6qHcl+5TuMcPe6fv1IoE149iKnQyRJxgleWsW1W5yunhX78ruDd0eDe6fl5MfFnw6rgHQMrLYkd6XMiGCi9xF/73shJJxoPfbW3zSY1qB+jvj3oTei9almzMF5+6A6J09QqRLVOfzeWnnSsWkRSPCZtIXXTX2ukofdow1BO9prbomDIGT0FA6tsjZsUmwj7VaYZa4Rya8mzhOSo84U5R5ehxIxbtpFsIq2MkWeDnGV9H7xsaAqg/3koWWO77mcQfijiioRTXIXC1FaeeAnufAUBpmoXZCCGTjo35BP6746GYFuZYp0upyUg4zNghLS/WvoXcxuiZy90kARbWKQqC72izvVNyma7fS7CMath4Y+Fjsr7WRj6DUe/IRVgPBiUCANbGCaF9KF/GxkCKHf2OfcN0XgPNr5EExIPGr7/DZ+wv4lyQEH3HAhSjUlq1HRABdfMUGll9pLCpt2oeKkiMBkTKMybwON1zenmTT3ZjqRf3khaPfKqvSqnGXePQJJgPlT0RzeY8+CGk/VzSt04KBnQx2+4G/OozTYJZCevtqI5UaslXkCLBJvZ8+Jde04enkN/B4fvI/FhVjPKZLL4j7zgbyr/KVIyb5ocPL9FZc44oDoT9dhLpNVx5C5a47XL5PciiFK8oHHyBovH5Jl1KwkCfLuJ9GFX7MvbyEgnHlzyijNQnIFdL5jzHfvMggeP7grKWWBWtz8rGFfRSYVxMlSJTK1DUoM+4GueZ9iDl4V8fPSb0MmBbg7UFJzeu/Nv2GKEEzK5bjHYA4395PP/uq5E3joUNnn+UA4F7vDC8t9MKL0EGHHk1mGqDvFdNRndd8FwVoA3L+nxzC77n08SAz7OweMSTQtI6WNJ1rhweFy+5iPHfcYsCP72FCVuwIwjin8Cjs7bwNrW4E7X8+pKaYkgb1b5Zj/y5g/5GTVel0e+RNRg4waR/9MnLLVCNzoKOLMEpRqOcv2/K2xvyIW6ITKQykn3iSPGMAqEQTQMstoRd9YlhU3aAPeePLRqJ+fbD0rOXZmz3RTVYbn/kAMPyW6nFEiO8gTF9nfnStO0uCDJ95gFa+79oXsqrsl2/nWxefLTt+Bwjb9N6GHHzNr0GTS4SUEfeK89GE7O6HxcuwVseWZMqs/4ErcMLvgGXwFvjKTvBmnMVoKn/Hhmcxaarqb/JnjTtMyB8vMcy+uD9+cE99yN8PEbfm/OnVkfjiE96+Lt9cZArf3MEODt8/0yaRglXJsng1rhomlRFKWLt85JapFVF3fp/S+n8Up9LP1mboiOrgKL92T+MBxjNGnfXE9bnLqLSAhZigFaGjIr3BwBhSt1ZwomSXn3yZ6pJ33x5JcB14Bi0wjHVwP0UTmsm6ybeJirKGd/ZZIFPjpojIOaQJuY1sJ7xDOgsGcbltW6/5ZXZsX5UekhH95fJMNNHL47megs+VgkadeEKDZKNQPzvSlQBwxmyeyUJ3lDDG7JzAsal/bz8i1FjFqNxg7Q3XnI5pS+m1K4JHJaFg9Z3A8Lm2mHRJaFxJN0x5MqxINPf5aDR5Hkoetk7LM7hlVjgBEru5mKzT5CpNKD6Pbm0PcqHXrF3mbGzwY3shpXQeo/j0T4cXsdcj7qbCq1LY0O3z6iNe/BdisnEc9CBdy5bEvGbvC3bGZVeQqbPVflpA40uNIWpxP+jWl6fHvc/MVqER7ADBUxbgNOBv9+cdeDpQSaJAeu36qfpKX3zZ9fXgx4UriHgYApqdKzfCfWKw6XhhaAXsqCEs3XeYjhg3P7EzaoyBxfQ+r2lNb+KbTPZGyCpwnJCn82Dqi1L9mVk9sRzfqEBUTB+prp1TbHkhgQHTfLMu8An1+QcnUfK85sxeGHEZ8/gRzgmM2SsGUDqXrfY61ISRhsHWFqkN50lNu2ENK9fSApELUZaaD9B/8HJw+FE3uRbIhkNHDrl5MuhIPybZ9YVUewvJZgUvhQ8PxYL9dwJdkBvmcpDSRGU44HAtswW+n6OWIkKj5dwMnOeWnqFSQARZGw4Ht3RpztULQEc3ruW4l9WWZuTih+DQQHsrjdHaQkBBVFdmQ5dLV08yg25XwfaLq6O48rca/SN8FxNTiWA516FFHmyhVTuFMUrJoKV/FuSpAsV3WevslZ5quRr+gcSAGALCFztWdSxzNSyad8N1KjxS5U4tAk468S/70SrJZEgexc4p3nI7+W9iRVbXMCuGFYrNQSGNcTeRrYb2reUgl4jTqrZs5Z6gVpSM1SqkENz+yiuPdg59Q/Wf9zQVd4xf1od9bMmvs42zf2RZX5zEKD+K4SbKjwko+R3vyLfMn7t8/84rqEr8QOFNMbbY8uDpCpS9M/HWEqNqta7pFyvSTTQvVFxAQn366fRXH7oFOvhJmW5gsZ9JkWj3bF8M72nU28QfO2gYJ9ry1DAHSXZk/aIECnYn0U6Kd7bINgzmpt3FeMHO51ugCaaNO2IEdtde4tkaEELZ2C6BzaawtYkzbgiGv4frQXZRPJq6mzTMWeTJ7Od6bt2H78EF+1OfMIoRky2A689mQIrp5IkfxF31dCP/nOfFFiBOomDHfXtJwVp0Cf6HlzbvsFIULnfBw/GUIJt6e88mdaSgaWdGEm0tZXqq+Ilw6eSKa9Y47wjYez0/Vq/bls/EMuPaDu4yEpvFQ6zTm8vKNPkZzdmUrcfJ1cxDU+GxV7s6cVaN9wQZnO1sniXk1LZWHpBN+bExaKdQ24qCAxS7ZrwB56gmz8XZYVaaQYvw0y/BoH/yCCleoLoJrwh1audvlqtVr8p0h7NNt49CA0jUSZl3CPVte/H/fER6sbID8OLDedZcNbmggZEkRxYzBnnc8drcCMxVYLyrqrQe2wbcbt7FMmeKzwC4DGdy/G0d/I/ejzgg+tbgQQnviN+YCJyqt4hYee6dB2dhKpKI6XESjJIBeGAyS+KDp24PzTKLajyCxy7A7xTb1ulkDQtQiaSlceEm42Jwt7B3FZy66ABZbiTWwbq++KYOXC4WKTGs6gG363ghGyQ55yAQNcD96SHKwGIkX3tV5t3yBIk7Xzy4JCvDa9+4ZAIobDgNvQVYdydy60DCk2szMQQAQUPdDCGH+K4OsOTMwKJanS18YS1tj/L1lQjUob0cEWnzYKzjtdVdw49RyRaI+9kWjfGf3ux1OWtyEHrihHJKUerUcHdIhQOHPwuwaGmp1QlHTnGomeSQRkLffi3+1X4KHEGWmZbAAABVXrjgLq0AJGwkv/EARJ9208JAaur30nxiCNyrVDkKvfCzNUctRvT6VdrsruS1WKnNT4rI9kdqK8WNfAQ9O1wvjK5sw4GrJDu4RoPAAAGFAAAAAAAAA='
    },
    {
      id: 3,
      name: 'Google Pixel 8',
      price: 100799,
      category: 'Mobiles',
      description: 'Google Pixel 8 brings you pure Android experience with Tensor G3 chip, AI-powered features, and top-tier photography.',
      image: 'https://fdn2.gsmarena.com/vv/pics/google/google-pixel-8-1.jpg'
    },
    {
      id: 4,
      name: 'Drill Machine Kit',
      price: 10129,
       category: 'Tools',
      description: 'A complete electric drill machine kit with bits for appliance repairs, wall mounting, and basic installations.',
      image:'https://n4.sdlcdn.com/imgs/j/m/4/BD-102-DRILL-KIT-550W-SDL139516784-1-f22f2.jpeg'
    },
    {
      id: 5,
      name: 'Plumbing Tool Set',
      price:11089,
      category: 'Plumbing',
      description: 'Multi-purpose plumbing tool set with wrench, pipe cutter, sealant, and accessories for home plumbing repairs.',
      image:'https://th.bing.com/th/id/OIP.Ved6sTrvt5wT9tXTzdWAVQHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1'
    },
    {
      id: 6,
      name: 'Wall Painting Kit',
      price:2059,
      category: 'Painting',
      description: 'All-in-one wall painting kit with rollers, paint tray, masking tape, brushes and extension rods.',
image:'https://th.bing.com/th/id/OIP.dkD9vE5Pgr8xotJTp519OQHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1'
    },
    {
      id: 7,
      name: 'Home Cleaning Starter Pack',
      price: 49,
      category: 'Cleaning',
      description: 'Includes microfiber mop, bucket, gloves, eco-friendly sprays and sponges for professional cleaning at home.',
image:'https://th.bing.com/th/id/OIP.rvHDJhfa489756ZkgKSTrQHaEy?w=284&h=184&c=7&r=0&o=7&pid=1.7&rm=3'    
    },
    {
      id: 8,
      name: 'Electric Screwdriver Set',
      price: 3139,
      category: 'Tools',
      description: 'Cordless rechargeable screwdriver set with magnetic bits – ideal for quick appliance fixes.',
image:'https://th.bing.com/th/id/OIP.FsViu93xSlBw4qYx0aUqSgAAAA?w=174&h=180&c=7&r=0&o=7&pid=1.7&rm=3'
    },
    {
      id: 9,
      name: 'Pipe Leak Repair Tape',
      price: 15,
      category: 'Plumbing',
      description: 'Waterproof silicone self-fusing tape for emergency plumbing repairs and sealing leaks.',
image:'https://images-na.ssl-images-amazon.com/images/I/71u3RX96aWL._AC_SL1500_.jpg'
    },
    {
      id: 10,
      name: 'Painter’s Coverall Set',
      price: 1025,
      category: 'Painting',
      description: 'Disposable painting coveralls with gloves, cap, and shoe covers for clean and safe painting.',
image:'https://th.bing.com/th/id/OIP.fArqYIBf6WJuhSZ_3EkOIAHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1'
    },
    {
      id: 11,
      name: 'Extendable Duster Kit',
      price: 522,
      category: 'Cleaning',
      description: 'Microfiber duster with extendable handle for ceiling fans, vents, and hard-to-reach places.',
image:'https://m.media-amazon.com/images/I/71r7NBywvUL.jpg'
    },
    {
      id: 12,
      name: 'Sink Unclogging Pump',
      price: 735,
      category: 'Plumbing',
      description: 'Powerful plunger pump to unclog kitchen/bathroom sinks and floor drains in seconds.',
image:'https://th.bing.com/th/id/OIP.G7BqmWUctJrLawcX2qOufwHaE6?rs=1&pid=ImgDetMain&cb=idpwebpc1'
    },
    {
      id: 13,
      name: 'Wall Crack Filler Paste',
      price: 58,
       category: 'Painting',
      description: 'Easy-to-use putty for repairing small cracks in walls before painting.',
image:'https://m.media-amazon.com/images/I/51Xicnd8cmL._SL1000_.jpg'
    },
{
  id: 14,
  name: 'Men\'s Cotton T-Shirt',
  price: 499,
  category: 'Mens Clothes',
  description: 'Breathable round-neck t-shirt made from 100% cotton – perfect for everyday wear.',
  image:'https://th.bing.com/th/id/OIP.A6pas5ib5oP0fBdh-b6zZAHaJ-?rs=1&pid=ImgDetMain&cb=idpwebpc1'
},
{
  id: 15,
  name: 'Women\'s Denim Jacket',
  price: 1699,
  category: 'Women Clothes',
  description: 'Classic blue denim jacket with button front – a timeless fashion staple for all seasons.',
  image: 'https://m.media-amazon.com/images/I/81kMslz7JkL._AC_SR736,920_.jpg'
},
{
  id: 16,
  name: 'Unisex Hoodie Sweatshirt',
  price: 1199,
  category: 'Unisex',
  description: 'Comfortable fleece-lined hoodie with front pocket and drawstring hood.',
  image: 'https://i5.walmartimages.com/asr/24290ef3-e1df-4c35-9334-336fd932d7c4.91d21b7ea89381efc423f0225ca85c06.jpeg?odnWidth=1000&odnHeight=1000&odnBg=ffffff'
},
{
  id: 17,
  name: 'Women\'s Yoga Leggings',
  price: 849,
  category: 'Women Clothes',
  description: 'High-waisted stretch leggings designed for fitness, yoga, or casual wear.',
  image: 'https://th.bing.com/th/id/OIP.wn6IF5jo6br269Ffgr0mKAHaJz?rs=1&pid=ImgDetMain&cb=idpwebpc1'
},
{
  id: 18,
  name: 'Men\'s Formal Shirt',
  price: 1095,
  category: 'Mens Clothes',
  description: 'Slim-fit button-up shirt suitable for office or formal occasions.',
  image: 'https://assetscdn1.paytm.com/images/catalog/product/A/AP/APPPETER-ENGLANADIT50996AF0E9514/1562790387722_1..jpg'
},
{
  id: 19,
  name: 'Men\'s Running Shoes',
  price: 2399,
  category: 'Footwear',
  description: 'Lightweight and breathable running shoes with cushioned soles for all-day comfort and performance.',
  image: 'https://static.runnea.com/images/202110/nike-air-zoom-next-1-800x800x80.jpg?1'
},
{
  id: 20,
  name: 'Women\'s Formal Heels',
  price: 1899,
  category: 'Footwear',
  description: 'Elegant pointed-toe heels perfect for office wear or special occasions.',
  image: 'https://th.bing.com/th/id/OIP.35m6OvW1Hq4iZM2sknZbnwHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1'
},
{
  id: 21,
  name: 'Unisex Safety Boots',
  price: 2799,
  category: 'Footwear',
  description: 'Heavy-duty safety boots with steel toe cap and slip-resistant sole – ideal for industrial work.',
  image: 'https://res.cloudinary.com/rsc/image/upload/bo_1.5px_solid_white,b_auto,c_pad,dpr_2,f_auto,h_399,q_auto,w_710/c_pad,h_399,w_710/F2458902-01?pgw=1'
},
{
  id: 22,
  name: 'Hydrating Facial Serum',
  price: 1599,
  category: 'Cosmetics',
  description: 'A lightweight serum infused with hyaluronic acid to deeply hydrate and rejuvenate the skin.',
  image: 'https://m.media-amazon.com/images/I/61rtmqz74HL._SL1500_.jpg'
},{
  id: 23,
  name: 'Matte Liquid Lipstick',
  price: 899,
  category: 'Cosmetics',
  description: 'Long-lasting matte liquid lipstick that glides on smoothly and stays vibrant all day.',
  image: 'https://m.media-amazon.com/images/I/71Lp1ILEsUL._AC_SL1500_.jpg'
},
{
  id: 24,
  name: 'Volumizing Mascara',
  price: 1299,
  category: 'Cosmetics',
  description: 'Smudge-proof mascara that adds dramatic volume and curl to your lashes.',
  image: 'https://th.bing.com/th/id/OIP.lTDs1gos4GszEKFBFPB6EAHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc2'
},
{
  id: 25,
  name: 'Nourishing Face Cream',
  price: 1799,
  category: 'Cosmetics',
  description: 'Rich, nourishing face cream with shea butter and vitamin E for all-day hydration.',
  image: 'https://i5.walmartimages.com/seo/Mareep-Hydrating-Creams-Moisturizers-Cream-Nourishing-Face-CreamRetinol-Activating-Night-Firming-Light-Lines-Moisturizing-And-Against-Aging-Facial_c089dfae-510e-4e2c-a4aa-1b5a49d98bf8.4c6a8b072d59423eddabc95f5da6d2da.jpeg'
},
{
  id: 26,
  name: 'Eyeshadow Palette – Nude Tones',
  price: 2499,
  category: 'Cosmetics',
  description: 'Versatile eyeshadow palette featuring 12 nude shades with matte and shimmer finishes.',
  image: 'https://th.bing.com/th/id/OIP.Cr0L0_pN6nbMB7peB5ljvwHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc2'
},
{
  id: 27,
  name: 'Sterling Silver Compass Pendant',
  price: 4999,
  category: 'Jewelry',
  description: 'Sterling silver compass pendant with nautical engraving—ideal as a meaningful gift or everyday accessory.',
  image: 'https://capecodjewelers.com/cdn/shop/products/Sterling_Silver_Compass_Rose_Pendant_on_Chain_93312772-3548-40c3-8f86-a629007f17ef.jpg?v=1714662947&width=1500'
},
{
  id: 28,
  name: '14K Gold-Plated Hoop Earrings (6‑pair set)',
  price: 2799,
  category: 'Jewelry',
  description: 'Pack of six stylish hypoallergenic gold-plated hoops in various sizes—perfect for layering or gifting.',
  image: 'https://th.bing.com/th/id/OIP.-7FvRJBE95OH-xztMWPSSgAAAA?pid=ImgDet&w=300&h=300&rs=1&cb=idpwebpc2'
},
{
  id: 29,
  name: 'Sterling Silver Tree of Life Pendant',
  price: 3999,
  category: 'Jewelry',
  description: 'Elegant circular pendant featuring a Tree of Life motif—crafted in sterling silver for unisex appeal.',
  image: 'https://i.etsystatic.com/23841683/r/il/42b069/5788718660/il_1080xN.5788718660_e2kq.jpg'
},
{
  id: 30,
  name: 'Sterling Silver Cat & Moon Pendant',
  price: 3599,
  category: 'Jewelry',
  description: 'Charming sterling silver pendant featuring a cat sitting on a crescent moon—great conversation starter.',
  image: 'https://i.etsystatic.com/10912802/r/il/04a887/2852402054/il_1140xN.2852402054_pk1r.jpg'
}
,
{
  id: 31,
  name: '1 send test',
  price: 1,
  category: 'Footwear',
  description: 'testing work.',
  image:'https://en.numista.com/catalogue/photos/inde/626e322c2a7ef4.52812450-original.jpg'
}

  ];



 export const getSpecifications = (category) => {
  switch (category) {
    case "Mobiles":
      return [
        { label: "Display", value: "6.1‑inch Super Retina XDR OLED" },
        { label: "Processor", value: "A15 Bionic Chip" },
        { label: "Camera", value: "12MP Dual Camera" },
        { label: "Battery", value: "Up to 20 hours video playback" },
        { label: "Storage", value: "128GB" },
        { label: "Operating System", value: "iOS 16" },
      ];
    case "Tools":
      return [
        { label: "Power", value: "550W" },
        { label: "Drill Type", value: "Electric" },
        { label: "Includes Bits", value: "Yes" },
        { label: "Usage", value: "Home Repairs" },
        { label: "Corded", value: "Yes" },
      ];
    case "Mens Clothes":
      return [
        { label: "Fabric", value: "100% Cotton" },
        { label: "Fit", value: "Regular" },
        { label: "Sleeve", value: "Half Sleeve" },
        { label: "Neck", value: "Round Neck" },
        { label: "Occasion", value: "Casual" },
      ];
    case "Cosmetics":
      return [
        { label: "Skin Type", value: "All Skin Types" },
        { label: "Main Ingredient", value: "Hyaluronic Acid" },
        { label: "Application", value: "Face" },
        { label: "Type", value: "Serum" },
        { label: "Volume", value: "30ml" },
      ];
    case "Jewelry":
      return [
        { label: "Material", value: "Sterling Silver" },
        { label: "Design", value: "Compass Rose" },
        { label: "Finish", value: "Polished" },
        { label: "Chain Included", value: "Yes" },
        { label: "Gender", value: "Unisex" },
      ];
    default:
      return [];
  }
};

// export default{ProductCategory, getSpecifications };

  // export default ProductCategory;








//   export const products = [
//   {
//     id: 1,
//     name: "Kwality Walls The Dairy Factory Slow Churned Alphonso Mango Ice Cream",
//     price: 127.0,
//     originalPrice: 150.0,
//     discount: "15% OFF",
//     image: "https://via.placeholder.com/120x120/FFB347/FFFFFF?text=Mango",
//     category: "ice-cream",
//     brand: "Kwality Walls",
//     description: "Rich and creamy mango ice cream made with real Alphonso mangoes",
//     rating: 4.5,
//     inStock: true,
//     weight: "1L",
//   },
//   {
//     id: 2,
//     name: "Kwality Walls The Dairy Factory Slow Churned Chocolate Ice Cream",
//     price: 136.0,
//     originalPrice: 160.0,
//     discount: "15% OFF",
//     image: "https://via.placeholder.com/120x120/8B4513/FFFFFF?text=Chocolate",
//     category: "ice-cream",
//     brand: "Kwality Walls",
//     description: "Decadent chocolate ice cream with rich cocoa flavor",
//     rating: 4.7,
//     inStock: true,
//     weight: "1L",
//   },
//   {
//     id: 3,
//     name: "Hershey's Vanilla Ice Cream Flavoured Milkshake 180 ml",
//     price: 32.0,
//     originalPrice: 40.0,
//     discount: "20% OFF",
//     image: "https://via.placeholder.com/120x120/F5DEB3/000000?text=Vanilla",
//     category: "milkshake",
//     brand: "Hershey's",
//     description: "Smooth vanilla flavored milkshake ready to drink",
//     rating: 4.2,
//     inStock: true,
//     weight: "180ml",
//   },
//   {
//     id: 4,
//     name: "Amul Butterscotch Ice Cream 1L",
//     price: 180.0,
//     originalPrice: 200.0,
//     discount: "10% OFF",
//     image: "https://via.placeholder.com/120x120/DAA520/FFFFFF?text=Butterscotch",
//     category: "ice-cream",
//     brand: "Amul",
//     description: "Creamy butterscotch ice cream with crunchy caramel bits",
//     rating: 4.4,
//     inStock: true,
//     weight: "1L",
//   },
//   {
//     id: 5,
//     name: "Mother Dairy Strawberry Milkshake 200ml",
//     price: 25.0,
//     originalPrice: 30.0,
//     discount: "17% OFF",
//     image: "https://via.placeholder.com/120x120/FFB6C1/000000?text=Strawberry",
//     category: "milkshake",
//     brand: "Mother Dairy",
//     description: "Fresh strawberry milkshake with real fruit pulp",
//     rating: 4.1,
//     inStock: true,
//     weight: "200ml",
//   },
//   {
//     id: 6,
//     name: "Vadilal Malai Kulfi 85ml",
//     price: 45.0,
//     originalPrice: 50.0,
//     discount: "10% OFF",
//     image: "https://via.placeholder.com/120x120/FFF8DC/8B4513?text=Kulfi",
//     category: "kulfi",
//     brand: "Vadilal",
//     description: "Traditional Indian kulfi with rich malai flavor",
//     rating: 4.6,
//     inStock: true,
//     weight: "85ml",
//   },
//   {
//     id: 7,
//     name: "Havmor Pista Kulfi 100ml",
//     price: 55.0,
//     originalPrice: 65.0,
//     discount: "15% OFF",
//     image: "https://via.placeholder.com/120x120/90EE90/000000?text=Pista",
//     category: "kulfi",
//     brand: "Havmor",
//     description: "Authentic pistachio kulfi with real nuts",
//     rating: 4.8,
//     inStock: true,
//     weight: "100ml",
//   },
//   {
//     id: 8,
//     name: "Naturals Orange Popsicle 60ml",
//     price: 20.0,
//     originalPrice: 25.0,
//     discount: "20% OFF",
//     image: "https://via.placeholder.com/120x120/FFA500/FFFFFF?text=Orange",
//     category: "popsicle",
//     brand: "Naturals",
//     description: "Refreshing orange flavored ice pop",
//     rating: 4.0,
//     inStock: true,
//     weight: "60ml",
//   },
//   {
//     id: 9,
//     name: "Kwality Walls Cornetto Vanilla 110ml",
//     price: 65.0,
//     originalPrice: 75.0,
//     discount: "13% OFF",
//     image: "https://via.placeholder.com/120x120/F5DEB3/8B4513?text=Cornetto",
//     category: "frozen",
//     brand: "Kwality Walls",
//     description: "Crispy waffle cone filled with vanilla ice cream",
//     rating: 4.5,
//     inStock: true,
//     weight: "110ml",
//   },
//   {
//     id: 10,
//     name: "Baskin Robbins Chocolate Milkshake 300ml",
//     price: 120.0,
//     originalPrice: 140.0,
//     discount: "14% OFF",
//     image: "https://via.placeholder.com/120x120/8B4513/FFFFFF?text=BR+Shake",
//     category: "milkshake",
//     brand: "Baskin Robbins",
//     description: "Premium chocolate milkshake with rich flavor",
//     rating: 4.7,
//     inStock: true,
//     weight: "300ml",
//   },
//   {
//     id: 11,
//     name: "Amul Cassata Ice Cream 1L",
//     price: 195.0,
//     originalPrice: 220.0,
//     discount: "11% OFF",
//     image: "https://via.placeholder.com/120x120/FFE4E1/8B4513?text=Cassata",
//     category: "ice-cream",
//     brand: "Amul",
//     description: "Multi-layered ice cream with nuts and fruits",
//     rating: 4.3,
//     inStock: true,
//     weight: "1L",
//   },
//   {
//     id: 12,
//     name: "Vadilal Mango Popsicle 75ml",
//     price: 22.0,
//     originalPrice: 28.0,
//     discount: "21% OFF",
//     image: "https://via.placeholder.com/120x120/FFB347/000000?text=Mango+Pop",
//     category: "popsicle",
//     brand: "Vadilal",
//     description: "Natural mango flavored ice pop",
//     rating: 4.2,
//     inStock: true,
//     weight: "75ml",
//   },
//   {
//     id: 13,
//     name: "Havmor Choco Bar 85ml",
//     price: 35.0,
//     originalPrice: 40.0,
//     discount: "12% OFF",
//     image: "https://via.placeholder.com/120x120/8B4513/FFFFFF?text=Choco+Bar",
//     category: "frozen",
//     brand: "Havmor",
//     description: "Chocolate coated vanilla ice cream bar",
//     rating: 4.4,
//     inStock: true,
//     weight: "85ml",
//   },
//   {
//     id: 14,
//     name: "Mother Dairy Mango Milkshake 200ml",
//     price: 28.0,
//     originalPrice: 35.0,
//     discount: "20% OFF",
//     image: "https://via.placeholder.com/120x120/FFB347/000000?text=Mango+Shake",
//     category: "milkshake",
//     brand: "Mother Dairy",
//     description: "Tropical mango milkshake with real fruit",
//     rating: 4.3,
//     inStock: true,
//     weight: "200ml",
//   },
//   {
//     id: 15,
//     name: "Naturals Tender Coconut Kulfi 90ml",
//     price: 48.0,
//     originalPrice: 55.0,
//     discount: "13% OFF",
//     image: "https://via.placeholder.com/120x120/FFFFFF/8B4513?text=Coconut",
//     category: "kulfi",
//     brand: "Naturals",
//     description: "Refreshing tender coconut kulfi",
//     rating: 4.5,
//     inStock: true,
//     weight: "90ml",
//   },
//   // New products start from ID 16
//   {
//     id: 16,
//     name: "iPhone 14",
//     price: 103999,
//     originalPrice: 103999,
//     discount: "0% OFF",
//     category: "Mobiles",
//     description:
//       "The iPhone 14 features a sleek design, powerful A15 Bionic chip, dual-camera system, and improved battery life.",
//     image: "https://th.bing.com/th/id/OIP.3Jmu9Vp6t3XXsgRdGG9t2QAAAA?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Apple",
//     rating: 4.8,
//     inStock: true,
//     weight: "200g",
//   },
//   {
//     id: 17,
//     name: "Samsung Galaxy S24",
//     price: 78099,
//     originalPrice: 78099,
//     discount: "0% OFF",
//     category: "Mobiles",
//     description:
//       "Samsung Galaxy S24 offers a stunning AMOLED display, Snapdragon 8 Gen 2, and pro-grade triple-lens camera.",
//     image: "https://fdn2.gsmarena.com/vv/pics/samsung/samsung-galaxy-s24-ultra-1.jpg",
//     brand: "Samsung",
//     rating: 4.7,
//     inStock: true,
//     weight: "230g",
//   },
//   {
//     id: 18,
//     name: "Google Pixel 8",
//     price: 100799,
//     originalPrice: 100799,
//     discount: "0% OFF",
//     category: "Mobiles",
//     description:
//       "Google Pixel 8 brings you pure Android experience with Tensor G3 chip, AI-powered features, and top-tier photography.",
//     image: "https://fdn2.gsmarena.com/vv/pics/google/google-pixel-8-1.jpg",
//     brand: "Google",
//     rating: 4.6,
//     inStock: true,
//     weight: "187g",
//   },
//   {
//     id: 19,
//     name: "Drill Machine Kit",
//     price: 10129,
//     originalPrice: 10129,
//     discount: "0% OFF",
//     category: "Tools",
//     description:
//       "A complete electric drill machine kit with bits for appliance repairs, wall mounting, and basic installations.",
//     image: "https://n4.sdlcdn.com/imgs/j/m/4/BD-102-DRILL-KIT-550W-SDL139516784-1-f22f2.jpeg",
//     brand: "Bosch",
//     rating: 4.2,
//     inStock: true,
//     weight: "2kg",
//   },
//   {
//     id: 20,
//     name: "Plumbing Tool Set",
//     price: 11089,
//     originalPrice: 11089,
//     discount: "0% OFF",
//     category: "Plumbing",
//     description:
//       "Multi-purpose plumbing tool set with wrench, pipe cutter, sealant, and accessories for home plumbing repairs.",
//     image: "https://th.bing.com/th/id/OIP.Ved6sTrvt5wT9tXTzdWAVQHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Stanley",
//     rating: 4.0,
//     inStock: true,
//     weight: "1.5kg",
//   },
//   {
//     id: 21,
//     name: "Wall Painting Kit",
//     price: 2059,
//     originalPrice: 2059,
//     discount: "0% OFF",
//     category: "Painting",
//     description: "All-in-one wall painting kit with rollers, paint tray, masking tape, brushes and extension rods.",
//     image: "https://th.bing.com/th/id/OIP.dkD9vE5Pgr8xotJTp519OQHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Asian Paints",
//     rating: 4.1,
//     inStock: true,
//     weight: "500g",
//   },
//   {
//     id: 22,
//     name: "Home Cleaning Starter Pack",
//     price: 49,
//     originalPrice: 49,
//     discount: "0% OFF",
//     category: "Cleaning",
//     description:
//       "Includes microfiber mop, bucket, gloves, eco-friendly sprays and sponges for professional cleaning at home.",
//     image: "https://th.bing.com/th/id/OIP.rvHDJhfa489756ZkgKSTrQHaEy?w=284&h=184&c=7&r=0&o=7&pid=1.7&rm=3",
//     brand: "Lizol",
//     rating: 3.9,
//     inStock: true,
//     weight: "1kg",
//   },
//   {
//     id: 23,
//     name: "Electric Screwdriver Set",
//     price: 3139,
//     originalPrice: 3139,
//     discount: "0% OFF",
//     category: "Tools",
//     description: "Cordless rechargeable screwdriver set with magnetic bits – ideal for quick appliance fixes.",
//     image: "https://th.bing.com/th/id/OIP.FsViu93xSlBw4qYx0aUqSgAAAA?w=174&h=180&c=7&r=0&o=7&pid=1.7&rm=3",
//     brand: "Black+Decker",
//     rating: 4.3,
//     inStock: true,
//     weight: "800g",
//   },
//   {
//     id: 24,
//     name: "Pipe Leak Repair Tape",
//     price: 15,
//     originalPrice: 15,
//     discount: "0% OFF",
//     category: "Plumbing",
//     description: "Waterproof silicone self-fusing tape for emergency plumbing repairs and sealing leaks.",
//     image: "https://images-na.ssl-images-amazon.com/images/I/71u3RX96aWL._AC_SL1500_.jpg",
//     brand: "Fevicol",
//     rating: 4.0,
//     inStock: true,
//     weight: "100g",
//   },
//   {
//     id: 25,
//     name: "Painter’s Coverall Set",
//     price: 1025,
//     originalPrice: 1025,
//     discount: "0% OFF",
//     category: "Painting",
//     description: "Disposable painting coveralls with gloves, cap, and shoe covers for clean and safe painting.",
//     image: "https://th.bing.com/th/id/OIP.fArqYIBf6WJuhSZ_3EkOIAHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "3M",
//     rating: 3.8,
//     inStock: true,
//     weight: "300g",
//   },
//   {
//     id: 26,
//     name: "Extendable Duster Kit",
//     price: 522,
//     originalPrice: 522,
//     discount: "0% OFF",
//     category: "Cleaning",
//     description: "Microfiber duster with extendable handle for ceiling fans, vents, and hard-to-reach places.",
//     image: "https://m.media-amazon.com/images/I/71r7NBywvUL.jpg",
//     brand: "Scotch-Brite",
//     rating: 4.4,
//     inStock: true,
//     weight: "250g",
//   },
//   {
//     id: 27,
//     name: "Sink Unclogging Pump",
//     price: 735,
//     originalPrice: 735,
//     discount: "0% OFF",
//     category: "Plumbing",
//     description: "Powerful plunger pump to unclog kitchen/bathroom sinks and floor drains in seconds.",
//     image: "https://th.bing.com/th/id/OIP.G7BqmWUctJrLawcX2qOufwHaE6?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Draino",
//     rating: 4.1,
//     inStock: true,
//     weight: "600g",
//   },
//   {
//     id: 28,
//     name: "Wall Crack Filler Paste",
//     price: 58,
//     originalPrice: 58,
//     discount: "0% OFF",
//     category: "Painting",
//     description: "Easy-to-use putty for repairing small cracks in walls before painting.",
//     image: "https://m.media-amazon.com/images/I/51Xicnd8cmL._SL1000_.jpg",
//     brand: "Dr. Fixit",
//     rating: 3.7,
//     inStock: true,
//     weight: "200g",
//   },
//   {
//     id: 29,
//     name: "Men's Cotton T-Shirt",
//     price: 499,
//     originalPrice: 499,
//     discount: "0% OFF",
//     category: "Mens Clothes",
//     description: "Breathable round-neck t-shirt made from 100% cotton – perfect for everyday wear.",
//     image: "https://th.bing.com/th/id/OIP.A6pas5ib5oP0fBdh-b6zZAHaJ-?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Levi's",
//     rating: 4.5,
//     inStock: true,
//     weight: "150g",
//   },
//   {
//     id: 30,
//     name: "Women's Denim Jacket",
//     price: 1699,
//     originalPrice: 1699,
//     discount: "0% OFF",
//     category: "Women Clothes",
//     description: "Classic blue denim jacket with button front – a timeless fashion staple for all seasons.",
//     image: "https://m.media-amazon.com/images/I/81kMslz7JkL._AC_SR736,920_.jpg",
//     brand: "Zara",
//     rating: 4.6,
//     inStock: true,
//     weight: "700g",
//   },
//   {
//     id: 31,
//     name: "Unisex Hoodie Sweatshirt",
//     price: 1199,
//     originalPrice: 1199,
//     discount: "0% OFF",
//     category: "Unisex",
//     description: "Comfortable fleece-lined hoodie with front pocket and drawstring hood.",
//     image:
//       "https://i5.walmartimages.com/asr/24290ef3-e1df-4c35-9334-336fd932d7c4.91d21b7ea89381efc423f0225ca85c06.jpeg?odnWidth=1000&odnHeight=1000&odnBg=ffffff",
//     brand: "H&M",
//     rating: 4.4,
//     inStock: true,
//     weight: "500g",
//   },
//   {
//     id: 32,
//     name: "Women's Yoga Leggings",
//     price: 849,
//     originalPrice: 849,
//     discount: "0% OFF",
//     category: "Women Clothes",
//     description: "High-waisted stretch leggings designed for fitness, yoga, or casual wear.",
//     image: "https://th.bing.com/th/id/OIP.wn6IF5jo6br269Ffgr0mKAHaJz?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Nike",
//     rating: 4.7,
//     inStock: true,
//     weight: "200g",
//   },
//   {
//     id: 33,
//     name: "Men's Formal Shirt",
//     price: 1095,
//     originalPrice: 1095,
//     discount: "0% OFF",
//     category: "Mens Clothes",
//     description: "Slim-fit button-up shirt suitable for office or formal occasions.",
//     image:
//       "https://assetscdn1.paytm.com/images/catalog/product/A/AP/APPPETER-ENGLANADIT50996AF0E9514/1562790387722_1..jpg",
//     brand: "Peter England",
//     rating: 4.3,
//     inStock: true,
//     weight: "250g",
//   },
//   {
//     id: 34,
//     name: "Men's Running Shoes",
//     price: 2399,
//     originalPrice: 2399,
//     discount: "0% OFF",
//     category: "Footwear",
//     description: "Lightweight and breathable running shoes with cushioned soles for all-day comfort and performance.",
//     image: "https://static.runnea.com/images/202110/nike-air-zoom-next-1-800x800x80.jpg?1",
//     brand: "Adidas",
//     rating: 4.8,
//     inStock: true,
//     weight: "400g",
//   },
//   {
//     id: 35,
//     name: "Women's Formal Heels",
//     price: 1899,
//     originalPrice: 1899,
//     discount: "0% OFF",
//     category: "Footwear",
//     description: "Elegant pointed-toe heels perfect for office wear or special occasions.",
//     image: "https://th.bing.com/th/id/OIP.35m6OvW1Hq4iZM2sknZbnwHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc1",
//     brand: "Bata",
//     rating: 4.5,
//     inStock: true,
//     weight: "300g",
//   },
//   {
//     id: 36,
//     name: "Unisex Safety Boots",
//     price: 2799,
//     originalPrice: 2799,
//     discount: "0% OFF",
//     category: "Footwear",
//     description: "Heavy-duty safety boots with steel toe cap and slip-resistant sole – ideal for industrial work.",
//     image:
//       "https://res.cloudinary.com/rsc/image/upload/bo_1.5px_solid_white,b_auto,c_pad,dpr_2,f_auto,h_399,q_auto,w_710/c_pad,h_399,w_710/F2458902-01?pgw=1",
//     brand: "Woodland",
//     rating: 4.2,
//     inStock: true,
//     weight: "1.2kg",
//   },
//   {
//     id: 37,
//     name: "Hydrating Facial Serum",
//     price: 1599,
//     originalPrice: 1599,
//     discount: "0% OFF",
//     category: "Cosmetics",
//     description: "A lightweight serum infused with hyaluronic acid to deeply hydrate and rejuvenate the skin.",
//     image: "https://m.media-amazon.com/images/I/61rtmqz74HL._SL1500_.jpg",
//     brand: "Mamaearth",
//     rating: 4.6,
//     inStock: true,
//     weight: "30ml",
//   },
//   {
//     id: 38,
//     name: "Matte Liquid Lipstick",
//     price: 899,
//     originalPrice: 899,
//     discount: "0% OFF",
//     category: "Cosmetics",
//     description: "Long-lasting matte liquid lipstick that glides on smoothly and stays vibrant all day.",
//     image: "https://m.media-amazon.com/images/I/71Lp1ILEsUL._AC_SL1500_.jpg",
//     brand: "Maybelline",
//     rating: 4.4,
//     inStock: true,
//     weight: "5ml",
//   },
//   {
//     id: 39,
//     name: "Volumizing Mascara",
//     price: 1299,
//     originalPrice: 1299,
//     discount: "0% OFF",
//     category: "Cosmetics",
//     description: "Smudge-proof mascara that adds dramatic volume and curl to your lashes.",
//     image: "https://th.bing.com/th/id/OIP.lTDs1gos4GszEKFBFPB6EAHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc2",
//     brand: "L'Oreal",
//     rating: 4.5,
//     inStock: true,
//     weight: "10ml",
//   },
//   {
//     id: 40,
//     name: "Nourishing Face Cream",
//     price: 1799,
//     originalPrice: 1799,
//     discount: "0% OFF",
//     category: "Cosmetics",
//     description: "Rich, nourishing face cream with shea butter and vitamin E for all-day hydration.",
//     image:
//       "https://i5.walmartimages.com/seo/Mareep-Hydrating-Creams-Moisturizers-Cream-Nourishing-Face-CreamRetinol-Activating-Night-Firming-Light-Lines-Moisturizing-And-Against-Aging-Facial_c089dfae-510e-4e2c-a4aa-1b5a49d98bf8.4c6a8b072d59423eddabc95f5da6d2da.jpeg",
//     brand: "Nivea",
//     rating: 4.3,
//     inStock: true,
//     weight: "50g",
//   },
//   {
//     id: 41,
//     name: "Eyeshadow Palette – Nude Tones",
//     price: 2499,
//     originalPrice: 2499,
//     discount: "0% OFF",
//     category: "Cosmetics",
//     description: "Versatile eyeshadow palette featuring 12 nude shades with matte and shimmer finishes.",
//     image: "https://th.bing.com/th/id/OIP.Cr0L0_pN6nbMB7peB5ljvwHaHa?rs=1&pid=ImgDetMain&cb=idpwebpc2",
//     brand: "NYX",
//     rating: 4.7,
//     inStock: true,
//     weight: "15g",
//   },
//   {
//     id: 42,
//     name: "Sterling Silver Compass Pendant",
//     price: 4999,
//     originalPrice: 4999,
//     discount: "0% OFF",
//     category: "Jewelry",
//     description:
//       "Sterling silver compass pendant with nautical engraving—ideal as a meaningful gift or everyday accessory.",
//     image:
//       "https://capecodjewelers.com/cdn/shop/products/Sterling_Silver_Compass_Rose_Pendant_on_Chain_93312772-3548-40c3-8f86-a629007f17ef.jpg?v=1714662947&width=1500",
//     brand: "Tanishq",
//     rating: 4.8,
//     inStock: true,
//     weight: "5g",
//   },
//   {
//     id: 43,
//     name: "14K Gold-Plated Hoop Earrings (6‑pair set)",
//     price: 2799,
//     originalPrice: 2799,
//     discount: "0% OFF",
//     category: "Jewelry",
//     description:
//       "Pack of six stylish hypoallergenic gold-plated hoops in various sizes—perfect for layering or gifting.",
//     image: "https://th.bing.com/th/id/OIP.-7FvRJBE95OH-xztMWPSSgAAAA?pid=ImgDet&w=300&h=300&rs=1&cb=idpwebpc2",
//     brand: "P.C. Chandra Jewellers",
//     rating: 4.5,
//     inStock: true,
//     weight: "10g",
//   },
//   {
//     id: 44,
//     name: "Sterling Silver Tree of Life Pendant",
//     price: 3999,
//     originalPrice: 3999,
//     discount: "0% OFF",
//     category: "Jewelry",
//     description:
//       "Elegant circular pendant featuring a Tree of Life motif—crafted in sterling silver for unisex appeal.",
//     image: "https://i.etsystatic.com/23841683/r/il/42b069/5788718660/il_1080xN.5788718660_e2kq.jpg",
//     brand: "Malabar Gold & Diamonds",
//     rating: 4.7,
//     inStock: true,
//     weight: "7g",
//   },
//   {
//     id: 45,
//     name: "Sterling Silver Cat & Moon Pendant",
//     price: 3599,
//     originalPrice: 3599,
//     discount: "0% OFF",
//     category: "Jewelry",
//     description:
//       "Charming sterling silver pendant featuring a cat sitting on a crescent moon—great conversation starter.",
//     image: "https://i.etsystatic.com/10912802/r/il/04a887/2852402054/il_1140xN.2852402054_pk1r.jpg",
//     brand: "Joyalukkas",
//     rating: 4.6,
//     inStock: true,
//     weight: "6g",
//   },
//   {
//     id: 46,
//     name: "1 send test",
//     price: 1,
//     originalPrice: 1,
//     discount: "0% OFF",
//     category: "Footwear",
//     description: "testing work.",
//     image: "https://en.numista.com/catalogue/photos/inde/626e322c2a7ef4.52812450-original.jpg",
//     brand: "TestBrand",
//     rating: 1.0,
//     inStock: true,
//     weight: "1g",
//   },
// ]
